import React, { useState, useEffect } from 'react';
import { useLocale } from 'components/special/LanguageProvider';

export const ErrorPage = (props) => {
  const { t } = useLocale();  

  return (    
    <div>              
       {t("Error PAGE")}        
    </div>                     
  );
}

